<template>
    <footer-container>
        <template v-slot:contacts>
            <footer-contacts></footer-contacts>
        </template>
        <template v-slot:categories>
            <footer-categories></footer-categories>
        </template>
    </footer-container>
</template>

<script>
    import FooterCategories from '../Categories/FooterCategories';
    import FooterContainer from '../Containers/FooterContainer';
    import FooterContacts from "../FooterContacts";
    export default {
        name: "FooterMain",
        components: {FooterContacts, FooterCategories, FooterContainer}
    };
</script>

<style scoped lang="scss">
</style>
